// src/e2ee/keys.ts

import { x25519 } from '@noble/curves/ed25519';
import { hkdf } from '@noble/hashes/hkdf';
import { sha256 } from '@noble/hashes/sha256';

/**
 * Generate ephemeral X25519 keypair for this session
 */
export function generateEphemeralKeypair(): {
  privateKey: Uint8Array;
  publicKey: Uint8Array;
} {
  const privateKey = x25519.utils.randomPrivateKey();
  const publicKey = x25519.getPublicKey(privateKey);
  return { privateKey, publicKey };
}

/**
 * Derive session key from shared secret using HKDF
 */
export function deriveSessionKey(
  privateKey: Uint8Array,
  theirPublicKey: Uint8Array
): Uint8Array {
  const sharedSecret = x25519.getSharedSecret(privateKey, theirPublicKey);

  return hkdf(
    sha256,
    sharedSecret,
    undefined,  // no salt
    'whss-e2ee-v1',
    32
  );
}

/**
 * Encode public key as base64
 */
export function encodePublicKey(publicKey: Uint8Array): string {
  return btoa(String.fromCharCode(...publicKey));
}

/**
 * Decode base64 public key
 */
export function decodePublicKey(base64: string): Uint8Array {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}
